import OtsPagination from "./OtsPagination"

OtsPagination.install = Vue => {
    vue.component(OtsPagination.name,OtsPagination)
}


export default OtsPagination